import { render, staticRenderFns } from "./TaskRules.vue?vue&type=template&id=312d10f4&scoped=true"
import script from "./TaskRules.vue?vue&type=script&lang=js"
export * from "./TaskRules.vue?vue&type=script&lang=js"
import style0 from "./TaskRules.vue?vue&type=style&index=0&id=312d10f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d10f4",
  null
  
)

export default component.exports